import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

import { vehicleStatusService } from "../../../../../services/guide/vehicleStatus-service";
import { useFetchGetVehicleStatusById } from "../../../../../hooks/guide/useFetchGetVehicleStatusById";
import { CreateVehicleStatus, UpdateVehicleStatus } from "../../../../../types/api/guide/vehicleStatus.types";

type FormState = { name: string };

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = { name: "" };

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };
        case "SET_All":
            return { ...action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

interface VehicleStatusAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id?: string;
}

export const VehicleStatusAddModal = ({ onClose, refetchData, id }: VehicleStatusAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const { data: status } = useFetchGetVehicleStatusById(id);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!status) return;
        dispatch({ type: "SET_All", payload: { name: status.name ?? "" } });
    }, [status]);

    const handleValue = (event: any) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name, value });
    };

    const canSave = useMemo(() => !!state.name.trim(), [state.name]);

    const handleSave = async () => {
        try {
            if (!status) {
                const payload: CreateVehicleStatus = { name: state.name.trim() };
                await vehicleStatusService.create(payload);
                showSuccess("Статус ТС создан");
            } else {
                const payload: UpdateVehicleStatus = { id: status.id, name: state.name.trim() };
                await vehicleStatusService.update(status.id, payload);
                showSuccess("Статус ТС обновлён");
            }

            refetchData();
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении статуса ТС");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {status ? "Редактировать статус ТС" : "Добавить статус ТС"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField name="name" value={state.name} onChange={handleValue} fullWidth />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>Отмена</button>
                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave}
                        style={{ opacity: canSave ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};
